module.exports = {
  preSaved: 'preSaved',
  saving: 'saving',
  saved: 'saved',
  deleting: 'deleting',
};
